export const styles = {
	root: {
		display: 'flex',
	},
	content: {
		display: 'flex',
		flexDirection: 'column',
		gap: '2rem',
		flexGrow: 1,
		paddingY: {
			xs: '0',
			sm: '1rem',
		},
	},
	headerSection: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'column',
		},
		justifyContent: 'space-between',
		gap: '1rem',
	},
	introRow: {
		display: 'flex',
		justifyContent: 'space-between',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		alignItems: {
			xs: 'flex-start',
			sm: 'center',
		},
		gap: '1rem',
		padding: 0,
	},
	mainContent: {
		marginLeft: '2rem',
		marginRight: '2rem',
	},
	buttonWrapper: {
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
	},
	editActions: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		gap: '2rem',
	},
	carouselWrapper: {
		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
		},
		alignItems: 'center',
		justifyContent: 'center',
		gap: '3rem',
		bgcolor: '#F5F5F5',
		padding: '2rem',
		'& .button-wrapper': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			border: '1px solid rgba(0, 0, 0, 0.23)',
			borderRadius: 50,
			width: 'max-content',

			'@media (max-width: 600px)': {
				border: 'none',
				flexWrap: 'wrap',
			},

			'& button': {
				fontSize: '14px',
				fontWeight: 500,
				color: 'rgba(0, 0, 0, 0.87)',
				padding: '10px',
				textTransform: 'uppercase',
				'@media (max-width: 1200px)': {
					fontSize: '12px',
				},
				'@media (max-width: 600px)': {
					borderRadius: 50,
					border: '1px solid rgba(0, 0, 0, 0.23)',
					marginTop: '5px',
					marginBottom: '5px',
				},
				':hover': {
					bgcolor: 'rgba(231, 248, 255, 0.4)',
				},
				backgroundColor: 'white',

				'&.selected': {
					bgcolor: '#D6D4FF',
				},

				'&:first-child': {
					borderTopLeftRadius: {
						sm: '18px',
						md: '18px',
					},
					borderBottomLeftRadius: {
						sm: '18px',
						md: '18px',
					},
				},

				'&:last-child': {
					borderTopRightRadius: {
						sm: '18px',
						md: '18px',
					},
					borderBottomRightRadius: {
						sm: '18px',
						md: '18px',
					},
				},
			},
		},
	},
	sideBar: {
		display: { xs: 'none', sm: 'block' },
		marginRight: '2rem',
		minWidth: '4px',
		background:
			'linear-gradient(180deg, rgba(0, 37, 230, 0.9) -12.94%, rgba(39, 35, 249, 0.5) 100%)',
	},
	editPromptsMode: {
		'.MuiInputBase-input': {
			fontWeight: '500',
			color: 'rgba(0, 0, 0, 0.87)',
			fontSize: {
				xs: 16,
				sm: 20,
			},
		},
		'.MuiOutlinedInput-notchedOutline': {
			border: 'none',
		},
		'.MuiOutlinedInput-root': {
			borderRadius: '0',
			borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
			backgroundColor: '#FFFFFF',
		},
	},
	promptsText: {
		color: 'rgba(0, 0, 0, 0.87)',
		fontWeight: 500,
		fontSize: {
			xs: 16,
			sm: 20,
		},
	},
	introText: {
		opacity: 0.87,
		fontSize: {
			xs: 16,
			sm: 20,
		},
		gap: '0.5rem',
		maxWidth: {
			sm: '488px',
			md: '600px',
			lg: '940px',
		},
	},
	promptCardOverrides: {
		backgroundColor: 'rgba(237, 231, 246, 0.8)',
	},
	ideasDropdownText: {
		opacity: 0.87,
		fontSize: {
			xs: 16,
			sm: 20,
		},
	},
	aiResponseContainer: {
		bgcolor: 'rgba(237, 231, 246, 0.8)',
		padding: '1rem',
	},
	aiResponseRole: {
		fontSize: 16,
		color: 'black',
	},
	aiResponseTopic: {
		fontSize: 16,
		color: 'black',
		opacity: 0.87,
		margin: '10px 0',
	},
	aiResponseSubpoint: {
		fontSize: 16,
		color: 'black',
	},
}

export const styleProps = {
	introText: {
		color: 'black' as const,
	},
	refreshIcon: {
		fontSize: 'small' as const,
	},
	responseTopic: {
		variant: 'body1' as const,
	},
	personaDivider: {
		orientation: 'vertical' as const,
		variant: 'middle' as const,
		flexItem: true,
	},
	saveButton: {
		color: 'secondary' as const,
		variant: 'contained' as const,
	},
	cancelButton: {
		color: 'secondary' as const,
		variant: 'text' as const,
	},
	ideasDropdownText: {
		color: 'black' as const,
	},
}
